import React, { useEffect, useState } from "react";
import "./AuditDetailsTable.scss";

const AuditDetailsTable = ({
  formDetails,
  tabName,
  onRadioChange,
  needCorrection = false,
  error,
}) => {
  const [tableData, setTableData] = useState([]);

  // Define which audit detail fields should NOT have correction options (red box fields)
  const nonEditableAuditFields = [
    "Will this be done in Conjunction with FSSC Certification Audit",
    "Audit Criteria (Applicable Standard or Technical Specifications)",
    "Audit Type",
    "Version",
    "Audit Focus Area",
    "Job Number"
  ];

  const isFieldEditable = (fieldLabel) => {
    return !nonEditableAuditFields.some(nonEditable => 
      fieldLabel.toLowerCase().includes(nonEditable.toLowerCase())
    );
  };

  const handleStatusChange = (id, status) => {
    setTableData((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, selectedStatus: status } : row
      )
    );
    let changedData = tableData.filter((row) => row.id === id);
    let changedObj = { ...changedData[0], selectedStatus: status };
    onRadioChange(id, changedObj, tabName, status);
  };

  useEffect(() => {
    // console.log("AuditDetailsTable - formDetails received:", formDetails);
    // console.log("AuditDetailsTable - formDetails type:", typeof formDetails);
    // console.log("AuditDetailsTable - formDetails isArray:", Array.isArray(formDetails));
    
    if (formDetails && !needCorrection) {
      // Handle both array and object data structures
      let dataArray = [];
      
      if (Array.isArray(formDetails)) {
        dataArray = formDetails;
      } else if (typeof formDetails === 'object' && formDetails !== null) {
        // If it's an object, convert to array format
        dataArray = Object.values(formDetails);
      }
      
      // console.log("AuditDetailsTable - processed dataArray:", dataArray);
      
      if (dataArray.length > 0) {
        setTableData(
          dataArray.map((item) => ({
            ...item,
            selectedStatus:
              item?.verificationStatus && item?.verificationStatus.toLowerCase() === "verified"
                ? "verified"
                : "correction",
          }))
        );
      } else {
        setTableData([]);
      }
    } else {
      // Handle needCorrection case
      let dataArray = [];
      
      if (Array.isArray(formDetails)) {
        dataArray = formDetails;
      } else if (typeof formDetails === 'object' && formDetails !== null) {
        dataArray = Object.values(formDetails);
      }
      
      setTableData(
        dataArray &&
          dataArray.map((item) => ({
            ...item,
          }))
      );
    }
  }, [formDetails, needCorrection]);

  // console.log("tableData", tableData);

  // Find the version value to determine filtering logic
  const versionRow = tableData.find(row => row.label === 'Version');
  const versionValue = versionRow ? parseInt(versionRow.value) : null;

  return (
    <div id="audit-details-table" className="audit-details-table-container">
      <table className="audit-details-table">
        <thead>
          <tr>
            <th
              style={{
                width: "30%",
                borderRadius: "10px 0px 0px 0px",
              }}
            >
              Field
            </th>
            <th
              style={{
                width: "50%",
                borderRadius: "0px 10px 0px 0px",
              }}
            >
              Response
            </th>
            <th
              style={{
                width: "20%",
                borderRadius: "0px 10px 0px 0px",
              }}
            >
              Verification status
            </th>
          </tr>
        </thead>
        <tbody>
          {!error && tableData && Array.isArray(tableData) &&
            tableData.length > 0 &&
            tableData.map((row) => {
              const isEditable = isFieldEditable(row.label);
              
              let shouldShowRow = true;
              
              if (versionValue === 1) {
                if (row.label === 'Correction Date') {
                  shouldShowRow = false;
                }
              }
              
              if (!shouldShowRow) {
                return null;
              }
              
              return (
                <tr key={row.id}>
                  <td style={{textTransform:"capitalize"}}>{row.label}</td>
                  <td style={{textTransform:"capitalize"}}>{row.value ? row.value : "N/A"}</td>
                  <td className="verification-section">
                    {isEditable ? (
                      <>
                        <div>
                          <label
                            htmlFor={`verified-audit-${row.id}`}
                            disabled={needCorrection}
                          >
                            <input
                              type="radio"
                              name={`audit-${tabName}-${row.id}`}
                              id={`verified-audit-${row.id}`}
                              value="verified"
                              checked={row.selectedStatus === "verified"}
                              onChange={() => {
                                if (needCorrection) {
                                  return;
                                } else {
                                  handleStatusChange(row.id, "verified");
                                }
                              }}
                              disabled={needCorrection}
                            />
                            <div className="verify-icon-section">
                              {row?.selectedStatus === "correction" && (
                                <div className="verify-icon-common">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M4.64968 7.87564L3.08818 6.31414C3.00404 6.23 2.88992 6.18273 2.77092 6.18273C2.65193 6.18273 2.53781 6.23 2.45367 6.31414C2.36953 6.39828 2.32227 6.5124 2.32227 6.63139C2.32227 6.69031 2.33387 6.74865 2.35642 6.80309C2.37897 6.85752 2.41201 6.90698 2.45367 6.94864L4.33468 8.82964C4.51018 9.00514 4.79368 9.00514 4.96918 8.82964L9.73018 4.06864C9.81432 3.9845 9.86158 3.87039 9.86158 3.75139C9.86158 3.6324 9.81432 3.51828 9.73018 3.43414C9.64604 3.35 9.53192 3.30273 9.41292 3.30273C9.29393 3.30273 9.17981 3.35 9.09567 3.43414L4.64968 7.87564Z"
                                      fill="#8D8D8D"
                                    />
                                  </svg>
                                </div>
                              )}{" "}
                              {row?.selectedStatus === "verified" && (
                                <div className="verify-icon-common verify-icon-green">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M4.64968 7.87564L3.08818 6.31414C3.00404 6.23 2.88992 6.18273 2.77092 6.18273C2.65193 6.18273 2.53781 6.23 2.45367 6.31414C2.36953 6.39828 2.32227 6.5124 2.32227 6.63139C2.32227 6.69031 2.33387 6.74865 2.35642 6.80309C2.37897 6.85752 2.41201 6.90698 2.45367 6.94864L4.33468 8.82964C4.51018 9.00514 4.79368 9.00514 4.96918 8.82964L9.73018 4.06864C9.81432 3.9845 9.86158 3.87039 9.86158 3.75139C9.86158 3.6324 9.81432 3.51828 9.73018 3.43414C9.64604 3.35 9.53192 3.30273 9.41292 3.30273C9.29393 3.30273 9.17981 3.35 9.09567 3.43414L4.64968 7.87564Z"
                                      fill="white"
                                    />
                                  </svg>
                                </div>
                              )}{" "}
                              <p>Verified</p>
                            </div>
                          </label>
                        </div>

                        <div>
                          <label
                            htmlFor={`correction-audit-${row.id}`}
                            disabled={needCorrection}
                          >
                            <input
                              type="radio"
                              name={`audit-${tabName}-${row.id}`}
                              id={`correction-audit-${row.id}`}
                              value="correction"
                              checked={row.selectedStatus === "correction"}
                              onChange={() => {
                                if (needCorrection) {
                                  return;
                                } else {
                                  handleStatusChange(row.id, "correction");
                                }
                              }}
                              disabled={needCorrection}
                            />
                            <div className="verify-icon-section">
                              {row?.selectedStatus === "verified" && (
                                <div className="verify-icon-common">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M9.15011 2.85511C9.10385 2.80876 9.04891 2.77199 8.98842 2.7469C8.92794 2.7218 8.8631 2.70889 8.79761 2.70889C8.73213 2.70889 8.66729 2.7218 8.6068 2.7469C8.54631 2.77199 8.49137 2.80876 8.44511 2.85511L6.00011 5.29511L3.55511 2.85011C3.50882 2.80382 3.45387 2.7671 3.39338 2.74205C3.3329 2.717 3.26808 2.7041 3.20261 2.7041C3.13715 2.7041 3.07232 2.717 3.01184 2.74205C2.95136 2.7671 2.8964 2.80382 2.85011 2.85011C2.80382 2.8964 2.7671 2.95136 2.74205 3.01184C2.717 3.07232 2.7041 3.13715 2.7041 3.20261C2.7041 3.26808 2.717 3.3329 2.74205 3.39338C2.7671 3.45387 2.80382 3.50882 2.85011 3.55511L5.29511 6.00011L2.85011 8.44511C2.80382 8.4914 2.7671 8.54636 2.74205 8.60684C2.717 8.66732 2.7041 8.73215 2.7041 8.79761C2.7041 8.86308 2.717 8.9279 2.74205 8.98838C2.7671 9.04887 2.80382 9.10382 2.85011 9.15011C2.8964 9.1964 2.95136 9.23312 3.01184 9.25817C3.07232 9.28323 3.13715 9.29612 3.20261 9.29612C3.26808 9.29612 3.3329 9.28323 3.39338 9.25817C3.45387 9.23312 3.50882 9.1964 3.55511 9.15011L6.00011 6.70511L8.44511 9.15011C8.4914 9.1964 8.54636 9.23312 8.60684 9.25817C8.66732 9.28323 8.73215 9.29612 8.79761 9.29612C8.86308 9.29612 8.9279 9.28323 8.98838 9.25817C9.04887 9.23312 9.10382 9.1964 9.15011 9.15011C9.1964 9.10382 9.23312 9.04887 9.25817 8.98838C9.28323 8.9279 9.29612 8.86308 9.29612 8.79761C9.29612 8.73215 9.28323 8.66732 9.25817 8.60684C9.23312 8.54636 9.1964 8.4914 9.15011 8.44511L6.70511 6.00011L9.15011 3.55511C9.34011 3.36511 9.34011 3.04511 9.15011 2.85511Z"
                                      fill="#8D8D8D"
                                    />
                                  </svg>
                                </div>
                              )}{" "}
                              {row?.selectedStatus === "correction" && (
                                <div className="verify-icon-common verify-icon-red">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M9.15011 2.85511C9.10385 2.80876 9.04891 2.77199 8.98842 2.7469C8.92794 2.7218 8.8631 2.70889 8.79761 2.70889C8.73213 2.70889 8.66729 2.7218 8.6068 2.7469C8.54631 2.77199 8.49137 2.80876 8.44511 2.85511L6.00011 5.29511L3.55511 2.85011C3.50882 2.80382 3.45387 2.7671 3.39338 2.74205C3.3329 2.717 3.26808 2.7041 3.20261 2.7041C3.13715 2.7041 3.07232 2.717 3.01184 2.74205C2.95136 2.7671 2.8964 2.80382 2.85011 2.85011C2.80382 2.8964 2.7671 2.95136 2.74205 3.01184C2.717 3.07232 2.7041 3.13715 2.7041 3.20261C2.7041 3.26808 2.717 3.3329 2.74205 3.39338C2.7671 3.45387 2.80382 3.50882 2.85011 3.55511L5.29511 6.00011L2.85011 8.44511C2.80382 8.4914 2.7671 8.54636 2.74205 8.60684C2.717 8.66732 2.7041 8.73215 2.7041 8.79761C2.7041 8.86308 2.717 8.9279 2.74205 8.98838C2.7671 9.04887 2.80382 9.10382 2.85011 9.15011C2.8964 9.1964 2.95136 9.23312 3.01184 9.25817C3.07232 9.28323 3.13715 9.29612 3.20261 9.29612C3.26808 9.29612 3.3329 9.28323 3.39338 9.25817C3.45387 9.23312 3.50882 9.1964 3.55511 9.15011L6.00011 6.70511L8.44511 9.15011C8.4914 9.1964 8.54636 9.23312 8.60684 9.25817C8.66732 9.28323 8.73215 9.29612 8.79761 9.29612C8.86308 9.29612 8.9279 9.28323 8.98838 9.25817C9.04887 9.23312 9.10382 9.1964 9.15011 9.15011C9.1964 9.10382 9.23312 9.04887 9.25817 8.98838C9.28323 8.9279 9.29612 8.86308 9.29612 8.79761C9.29612 8.73215 9.28323 8.66732 9.25817 8.60684C9.23312 8.54636 9.1964 8.4914 9.15011 8.44511L6.70511 6.00011L9.15011 3.55511C9.34011 3.36511 9.34011 3.04511 9.15011 2.85511Z"
                                      fill="white"
                                    />
                                  </svg>
                                </div>
                              )}{" "}
                              <p>Needs Correction</p>
                            </div>
                          </label>
                        </div>
                      </>
                    ) : (
                      <span style={{ color: "#666", fontStyle: "italic" }}>Verified</span>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      
      {(!tableData || !Array.isArray(tableData) || tableData.length === 0) && (
        <div style={{ 
          textAlign: "center", 
          padding: "40px", 
          color: "#666",
          fontStyle: "italic"
        }}>
          {!formDetails ? "Loading audit details..." : "No audit details available"}
        </div>
      )}
    </div>
  );
};

export default AuditDetailsTable; 